import { create } from "zustand";

type ApiRequestTrackerStore = {
  spinnerRequests: number;
  increment: () => void;
  decrement: () => void;
};
export const hasRunningRequestsSelector = (state: ApiRequestTrackerStore) =>
  state.spinnerRequests > 0;
export const useApiRequestTracker = create<ApiRequestTrackerStore>((set) => ({
  spinnerRequests: 0,
  increment: () =>
    set((state) => ({
      spinnerRequests: state.spinnerRequests + 1,
    })),
  decrement: () =>
    set((state) => ({
      spinnerRequests: Math.max(0, state.spinnerRequests - 1),
    })),
}));
